import script from "./ConstructionAdd.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConstructionAdd.vue?vue&type=script&lang=ts&setup=true"

import "./ConstructionAdd.vue?vue&type=style&index=0&id=65243d41&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65243d41"]])

export default __exports__